import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "columns is-vcentered" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "is-capitalized" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "column is-narrow"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.job.description), 1),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.job.status), 1),
          (_ctx.statusDate)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                title: _ctx.statusDate.toString()
              }, " " + _toDisplayString(_ctx.ago(_ctx.statusDate)), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_ctx.job.status === 'started')
          ? (_openBlock(), _createElementBlock("progress", _mergeProps({
              key: 0,
              class: "progress is-primary"
            }, _ctx.progressAttrs), null, 16))
          : _createCommentVNode("", true)
      ]),
      (_ctx.canDelete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-danger", { 'is-loading': _ctx.loading }]),
              disabled: _ctx.loading || undefined,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteJob && _ctx.deleteJob(...args)))
            }, _hoisted_10, 10, _hoisted_8)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}